<!-- Selecteur pour le  choix des chantiers disponible -->
<select (change)="onSiteChange($event.target.value, $event)" [disabled]="isDisabled" title="Site">
    <option *ngFor="let item of HTML_ARRAY_SITE" 
        [selected]="HTML_SelectSiteCode === item.CODECHANTIER" 
        [value]="item.CODECHANTIER">
        {{item.CODECHANTIER}} {{item.NOM}}
    </option>
</select>
